/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import EventPageDetailResendSearchbar from './searchbar';
import EventPageDetailResendBody from './body';
import { ResendModal } from './sendModal';
import { Link, withRouter } from 'react-router-dom';
import { GET, POST } from '/client/src/api';
import './styles.scss';
import _ from 'lodash';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

type PropsType = {
  match: {
    params: {
      tableTab?: string,
      eventId: number | string
    }
  }
};

const items = [
  {
    link: 'tickets',
    label: 'Tickets'
  },
  {
    link: 'receipts',
    label: 'Receipts'
  }
];

const EventPageDetailResend = ({ match }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const { params: { eventId } } = match;
  // Trigger to re-render table for do newone request to API
  // Hack for not touch old realisation in API side
  const [counter, _handleTriggerChangeTableContent] = React.useState(0);
  const handleTriggerChangeTableContent = () => {
    _handleTriggerChangeTableContent(counter + 1);
  };
  const [editRow, toggleEdit] = React.useState(null);
  const [pending, setPending] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [tableTab, setTableTab] = React.useState('tickets');
  const [skipCount, setSkipCount] = React.useState(0);
  const [totalRows, setTotalRows] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [maxResultCount, setMaxResultCount] = React.useState(100);
  const [searchString, setSearchString] = React.useState('');
  const [sortString, setSortString] = React.useState('');

  const fetchData =  async () => {
    setPending(true);

    try {
      // eslint-disable-next-line
      const ticketsUrl = `/api/v1/1/events/${eventId}/attendees?max_result_count=${maxResultCount}&skip_count=${skipCount}&has_voided=false&sorting=${sortString || 'order.paid_time_utc+desc'}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;
      const resUrl = `/api/v1/1/events/${eventId}/orders?max_result_count=${maxResultCount}&skip_count=${skipCount}&has_voided=false&search_type=all${searchString ? `&search_text=${  searchString}` : ''}`;

      const { result } = await GET(
        !tableTab ||
        tableTab.toLowerCase() === 'tickets' ||
        tableTab.toLowerCase() === '' ? ticketsUrl : resUrl);

        setRows(result.items);
        setTotalRows(result.total_count);
        setPending(false);
        toggleEdit(null);
    } catch (e) {
      console.log(e);
      console.error('Cant get orders');
      setPending(false);
    }
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSkipCount(page * maxResultCount - maxResultCount);
  };
  const handleMaxResultCount = (count: number) => {
    setMaxResultCount(count);
    setSkipCount(currentPage * count - count);
  };

  const [sendData, setSendData] = React.useState(null);
  const [isOpenModal, setOpenModal] = React.useState(false);
  const [modalPending, setModalPending] = React.useState(false);

  const SendTickets = async (need_update_code: boolean) => {
    setModalPending(true);

    const _data = [];

    _.map(sendData.selectedRows, (item: {}) => {
       _data.push({
         id: item.id,
         need_update_code,
         need_update_email: false
       });
    });

    try {
      await POST(`/api/v1/1/events/${eventId}/resend`, _data);

      context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully resend tickets'
      });

      setModalPending(false);
      setOpenModal(false);
    } catch (e) {
      console.log(e);

      const errorMsg = _.get(e, 'data.error', 'Can\'t resend tickets');

      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: errorMsg
      });

      setModalPending(false);
      setOpenModal(false);
    }
  };

  const SendReceipts = async () => {
    setModalPending(true);

    const _data = [];

    _.map(sendData.selectedRows, (item: {}): void => _data.push(item.id));

    try {
      await POST('/api/v1/1/orders/resend', _data);

      context.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully resend receipt'
      });

      setModalPending(false);
      setOpenModal(false);
    } catch (e) {
      console.log(e);

      const errorMsg = _.get(e, 'data.error.message', 'Can\'t resend receipt');

      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: errorMsg
      });

      setModalPending(false);
      setOpenModal(false);
    }
  };

  React.useEffect(() => {
    setSendData(null);
    fetchData();
  }, [eventId, tableTab, searchString, skipCount, maxResultCount, sortString]);

  const findAndReplaceRowData = (row: {}, newData: {}) => {
    if (!editRow || !newData) {
      return;
    }

    editRow.first_name = newData.first_name;
    editRow.last_name = newData.last_name;
    editRow.email_address = newData.email_address;

    toggleEdit(editRow);
  };

  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailResend-menuItems-${k}`}
        className={`${(tableTab ? tableTab.toLowerCase() : '') === i.link ? 'active' : ''}`}
        onClick={() => setTableTab(i.label.toLowerCase())}
      >
        <Link to={`/events/${eventId}/manage/resend/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });

  return (
    <div className="panel panel-default EventPageDetailResend">
      <div className="navbar-page-toolbar customers-navbar resend-navbar">
        <div className="container-fluid" style={{ height: '50px' }}>
          <ul className="nav hidden-520">
            {menuItems}
          </ul>

          <ul className="nav">
            <li className="dropdown hide show-520">
              <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false"
              >
                <i className="icon icon-bars" />
              </a>
              <ul className="dropdown-menu">
                {menuItems}
              </ul>
            </li>
          </ul>
        </div>

        <EventPageDetailResendSearchbar
          tableTab={tableTab}
          handleOpenModal={(): void => setOpenModal(true)}
          isNoSelectedItems={!sendData || !_.size(sendData.selectedRows)}
          handleSearch={setSearchString}
        />
      </div>
      <EventPageDetailResendBody
        tableTab={tableTab}
        counter={counter}
        data={rows}
        progressPending={pending}
        setSendData={setSendData}
        editRow={editRow}
        toggleEdit={toggleEdit}
        onHandleFindAndReplaceRowData={findAndReplaceRowData}
        maxResultCount={maxResultCount}
        setMaxResultCount={setMaxResultCount}
        currentPage={currentPage}
        totalRows={totalRows}
        handlePageChange={handlePageChange}
        handleSort={setSortString}
      />
      {isOpenModal &&
        <ResendModal
          isOpen={isOpenModal}
          tableTab={tableTab}
          handleCloseModal={(): void => setOpenModal(false)}
          data={sendData ? sendData.selectedRows : []}
          handleSendTickets={SendTickets}
          handleSendReceipts={SendReceipts}
          modalPending={modalPending}
        />
      }
    </div>
  );
};

export default withRouter(EventPageDetailResend);
